import { SecondaryButton } from '@luminalearning/components';
import { useIntl } from 'react-intl';
import ExploreLibaryCard from 'src/Components/RecourceLibary/ExploreLibaryCard';
import env from 'src/env';
import { useEffect } from 'react';
import useIsBrandfolderEnabled from 'src/hooks/useIsBrandfolderEnabled';
import supportURL from 'src/utils/supportUrl';
import MainLayout from 'src/Components/Pages/MainLayout';
import { useQuery } from '@apollo/client';
import GET_LOCALE from 'src/graphql/queries/intlQuery';
import AppCard from '../Apps/AppCard';
import ProductResourceCard from '../RecourceLibary/ProductResourceCard';
import ErrorContainer from '../Error/ErrorContainer';

const Resources = () => {
    const intl = useIntl();
    const { data: locale } = useQuery(GET_LOCALE);

    useEffect(() => {
        document.title = intl.formatMessage({ id: 'LP_RECOUCE_LIBARY_TITILE', defaultMessage: 'Resource Library' });
    }, [intl]);

    const {
        isBrandfolderEnabled,
        hasBrandfolderAccess,
        brandfolderError,
        brandfolderSignUp,
    } = useIsBrandfolderEnabled();

    return (
        <MainLayout>
            <div className='pb-20'>
                {brandfolderError
                    && <div className='w-search mb-6'>
                        <ErrorContainer errorMessage={intl.formatMessage({ id: 'LP_BRANDFOLDER_UNAVAILABLE', defaultMessage: 'Brandfolder unavailable' })} />
                    </div>
                }
                <div className='justify-center flex flex-col items-center lg:items-start'>
                    <span className='text-headline-lg font-bold ' style={{ lineHeight: '45px' }}>
                        {
                            intl.formatMessage({
                                id: 'LP_RECOUCE_LIBARY_TITILE',
                                defaultMessage: 'Resource Library',
                            })
                        }
                    </span>
                    <span className='text-label' style={{ lineHeight: '45px' }}>
                        {
                            intl.formatMessage({
                                id: 'LP_SUPPORT_DESK_SUB',
                                defaultMessage: 'Contact our Support Team for any assistance you might need',
                            })
                        }
                    </span>
                </div>
                {isBrandfolderEnabled
                    && <section className='w-70 mt-10'>
                        <ExploreLibaryCard
                            hasBrandfolderAccess={hasBrandfolderAccess}
                            isBrandfolderSignUp={isBrandfolderEnabled}
                            brandfolderError={brandfolderError}
                            brandfolderSignUp={brandfolderSignUp}
                        />
                    </section>
                }
                <div className='mt-8 flex flex-col justify-center xl:justify-start'>
                    <span className='text-headline-reg font-bold'>
                        {
                            intl.formatMessage({
                                id: 'LP_LUMINA_SHORTCUTS',
                                defaultMessage: 'Shortcuts',
                            })
                        }
                    </span>
                    <span className='text-headline-sm mt-4'>
                        {
                            intl.formatMessage({
                                id: 'LP_SHORTCUT_DESCRIPTION',
                                defaultMessage: 'Go straight to key resources and sections of the Resource Library',
                            })
                        }
                    </span>
                    <span className='text-subheading font-bold mt-6'>
                        {
                            intl.formatMessage({
                                id: 'LP_PRACTITIONER_BEST_PRACTICE',
                                defaultMessage: 'Practitioner Best Practices',
                            })
                        }
                    </span>
                </div>
                <section className=' xl:w-search flex flex-col md:flex-row
                                    sm:justify-center md:justify-center xl:justify-start mr-4 items-center'>
                    <AppCard
                        appName={
                            intl.formatMessage({
                                id: 'LP_SPARKING_UP_YOUR_WORKSHOP',
                                defaultMessage: 'Sparking Up Your Workshop',
                            })
                        }
                        appLogo={<img src={'/img/InPerson.png'} alt={
                            intl.formatMessage({
                                id: 'LP_SPARKING_UP_YOUR_WORKSHOP',
                                defaultMessage: 'Sparking Up Your Workshop',
                            })
                        } />}
                        body={
                            intl.formatMessage({
                                id: 'LP_SPARKING_UP_YOUR_WORKSHOP_EXPLAIN',
                                defaultMessage: 'A fully comprehensive guide for how to run the best workshops',
                            })
                        }
                        link='/spark-up-your-workshop'
                        internalLink={true}
                        isLoading={false}
                    />
                    <AppCard
                        appName={
                            intl.formatMessage({
                                id: 'LP_SPARKING_UP_YOUR_COACHING',
                                defaultMessage: 'Sparking Up Your Coaching',
                            })
                        }
                        appLogo={<img src={'/img/Coaching.png'} alt={
                            intl.formatMessage({
                                id: 'LP_SPARKING_UP_YOUR_COACHING',
                                defaultMessage: 'Sparking Up Your Coaching',
                            })
                        } />}
                        body={
                            intl.formatMessage({
                                id: 'LP_SPARKING_UP_YOUR_COACHING_EXPLAIN',
                                defaultMessage: 'How to best utilise Lumina Spark in your coaching practice',
                            })
                        }
                        link='/spark-up-your-coaching'
                        internalLink={true}
                        isLoading={false}
                    />
                </section>
                <div className='mt-8 flex flex-col justify-center xl:justify-start'>
                    <span className='text-subheading font-bold mt-6'>
                        {
                            intl.formatMessage({
                                id: 'LP_PRODUCT_RESOURCES',
                                defaultMessage: 'Product Resources',
                            })
                        }
                    </span>
                </div>
                {isBrandfolderEnabled
                    && <section
                        className='flex flex-wrap flex-col md:flex-row items-center justify-center xl:justify-start '>
                        <ProductResourceCard
                            appName={intl.formatMessage({ id: 'LP_PRODUCT_SPARK', defaultMessage: 'Lumina Spark' })}
                            link={`${env.brandfolderUrl}/lumina-spark`}
                            appLogo={<img src={'/img/lumina-spark-logo_orange-pos.png'} alt='' />}
                        />
                        <ProductResourceCard
                            appName={intl.formatMessage({ id: 'LP_PRODUCT_EMOTION', defaultMessage: 'Lumina Emotion' })}
                            link={`${env.brandfolderUrl}/lumina-emotion`}
                            appLogo={<img src={'/img/lumina-emotion-logo_purple-pos.png'} alt='' />}
                        />
                        <ProductResourceCard
                            appName={intl.formatMessage({ id: 'LP_PRODUCT_LEADER', defaultMessage: 'Lumina Leader' })}
                            link={`${env.brandfolderUrl}/lumina-leader`}
                            appLogo={<img src={'/img/lumina-leader-logo_light-blue-pos.png'} alt='' />}
                        />
                        <ProductResourceCard
                            appName={intl.formatMessage({ id: 'LP_PRODUCT_SALES', defaultMessage: 'Lumina Sales' })}
                            link={`${env.brandfolderUrl}/lumina-sales`}
                            appLogo={<img src={'/img/lumina-sales-logo_red-pos.png'} alt='' />}
                        />
                        <ProductResourceCard
                            appName={intl.formatMessage({ id: 'LP_LUMINA_SELECT', defaultMessage: 'Lumina Select' })}
                            link={`${env.brandfolderUrl}/lumina-select`}
                            appLogo={<img src={'/img/lumina-select-logo_blue-pos.png'} alt='' />}
                        />
                    </section>
                }

                <section className='mt-10 flex flex-col'>
                    <div className='flex items-center'>
                        <img src='/img/knowledge-base-icon@2x.png' className='h-60' alt={
                            intl.formatMessage({
                                id: 'LP_KNOWLEDGE_BASE',
                                defaultMessage: 'Knowledge Base',
                            })
                        }/>
                        <span>
                            <h1 className='text-headline-reg font-bold mb-6'>
                                {
                                    intl.formatMessage({
                                        id: 'LP_CHECK_KNOWLEDGE_BASE',
                                        defaultMessage: 'Check out our Knowledge Base',
                                    })
                                }
                            </h1>
                            <p className='text-paragraph-reg'>
                                {
                                    intl.formatMessage({
                                        id: 'LP_CHECK_KNOWLEDGE_BASE_EXPLAIN',
                                        defaultMessage: 'Explore Knowledge Base for FAQs, tutorials and support resources',
                                    })
                                }
                            </p>
                        </span>
                    </div>
                    <a href={supportURL(locale.appLocale)} target='_blank' rel='noopener noreferrer'>
                        <SecondaryButton
                            text={
                                intl.formatMessage({
                                    id: 'LP_KNOWLEDGE_BASE',
                                    defaultMessage: 'Knowledge Base',
                                })
                            }
                            hasArrow={true}
                            direction='Right'
                            className='w-9 ml-6'
                            onClick={() => { /** noop */ }}
                        />
                    </a>
                </section>
            </div>
        </MainLayout>
    );
};

export default Resources;